import { Block, Box, transitionsDelay } from '../../../styles/basicStyles';
import { breakpoints } from '../../../styles/breakpoints';
import styled from 'styled-components';

export const CategoryWrapper = styled(Block)`
  cursor: pointer;
  padding: 0.313rem 0.625rem;
  border-radius: 0.313rem;
  background-color: ${({ theme }) => theme.colors.lightPurple}; 
  transition: background-color ${transitionsDelay} linear;

  & span {
    transition: color ${transitionsDelay} linear;
    color: #4e429b; 
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.purple}; 

    & span {
      color: ${({ theme }) => theme.colors.white}; 
    }
  }
`;

export const TitleWrapper = styled(Block)`
  position: relative;
  display: inline-block;
  width: auto;

  &:before {
    content: '';
    position: absolute;
    top: -0.938rem;
    height: 0.188rem;
    background-color: ${({ theme }) => theme.colors.purple}; 
    width: 100%;
  }
`;

export const BlockWrapper = styled(Block)`
  display: flex;
  width: 100%;
  position: relative;

  & .react-reveal {
    width: 100%;
  }
`;

export const VideoContainer = styled(Block)<{maxWidth: number}>`
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth > 0 ? `${maxWidth}px` : "800px")};
`;

export const ShareContainer = styled(Block)`
  width: 100%;
  display: flex;
`;

export const SocialWrapper = styled(Box)`
  height: 2.313rem;
  width: 2.313rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.black}; 
  align-items: center;
  justify-content: center;
  transition: background-color ${transitionsDelay} linear;
  cursor: pointer;
  margin-left: 0.813rem;

  &:hover {
    background-color: ${({ theme }) => theme.colors.white}; 

     & svg {
      & path[stroke] {
        transition: stroke ${transitionsDelay} linear;
        stroke: ${({ theme }) =>  theme.colors.black};
      }

      & path[fill] {
        transition: fill ${transitionsDelay} linear;
        fill: ${({ theme }) =>  theme.colors.black};
      }
    }
  }
`;

export const ArticleWrapper = styled(Box)`
  cursor: pointer;
  
  & .image {
    transition: transform ${transitionsDelay} linear;
  }

  & .react-reveal {
    width: auto !important;
  }

  &:hover {
    & .image {
      transform: scale(1.05);
    }
  }
`;

export const ShareContainer2 = styled(Block)<{scrollTop: number}>`
  position: absolute;
  top: ${({ scrollTop }) => scrollTop + 290}px;
  right: -0.9375rem;
  padding: 0 1.0625rem;
  transition: top 0.8s linear;
  flex-direction: column;

  @media ${breakpoints.md} {
    display: none;
  }
`;

export const ShareWrapper = styled(Box)`
  height: 2.313rem;
  width: 2.313rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.black}; 
  align-items: center;
  justify-content: center;
  transition: background-color ${transitionsDelay} linear;
  cursor: pointer;
  margin-top: 0.625rem;

  &:hover {
    background-color: ${({ theme }) => theme.colors.white}; 

     & svg {
      & path[stroke] {
        transition: stroke ${transitionsDelay} linear;
        stroke: ${({ theme }) =>  theme.colors.black};
      }

      & path[fill] {
        transition: fill ${transitionsDelay} linear;
        fill: ${({ theme }) =>  theme.colors.black};
      }
    }
  }
`;

export const RelatedPostsWrapper = styled(Box)`
  flex-flow: row wrap;
  width: calc(100% + 2.312rem);

  @media ${breakpoints.xs} {
    width: 100%;
  }
`;

export const SourceLink = styled.a`
  text-decoration: underline;
  cursor: pointer;
  transition: color ${transitionsDelay} linear;
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 400;
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.colors.davyGrey};
  &:hover {
    color: ${({ theme }) => theme.colors.purple};
  }
`;

export const VideoWrapper = styled(Box)`
  & .react-reveal {
    width: 100%;

    & video, & iframe { 
      min-height: 28rem;
    }
  }
`;
